// @flow
export const BULB_SAVED = 'hive/lightbulbs/saved';
export const CHANGE_BRIGHTNESS = 'hive/lightbulbs/brightness';
export const CHANGE_COLOR_MODE = 'hive/color-picker/change-color-mode';
export const COLOR_CHANGED = 'hive/color-picker/color-changed';
export const TOGGLE_DONE = 'hive/lightbulbs/toggle-done';
export const TOGGLE_LIGHTBULB = 'hive/lightbulbs/toggle';
export const TALK_TO_LIGHT = 'hive/lightbulbs/talk';



// WEBPACK FOOTER //
// ./src/core/state/products/bulbs/constants.js